// @ts-nocheck
import breakpoint from "@toolkit/Framework/Common/Utilities/breakpoint";
import { css } from "styled-components";

export const productListPaginationWrapperStyles = () => {
    return css`
        justify-content: center;

        @media print {
            display: none;
        }
    `;
};
